// TODO[1648]: Get rid of that
import { Icon, type IconProps, type IconTypes } from '@ics-portal/guardian';

const iconComponentGenerator = (iconName: IconTypes) =>
    function IconComponent(props: Omit<IconProps, 'name'>) {
        return <Icon name={iconName} fontSize="normal" {...props} />;
    };

export const enum IconEntityMap {
    Dashboard = 'grid_view',
    DashboardCustomize = 'dashboard_customize',
    Projects = 'dashboard',
    SecurityNotification = 'gpp_maybe',
    MyTask = 'checkbook',
    ComponentLibrary = 'shapes',
    StandardsLibrary = 'library_books',
    Administration = 'admin_panel_settings',
    ProjectSummary = 'dashboard',
    ProjectTasks = 'task_alt',
    ProjectPSSPClassification = 'category',
    ProjectVulnerabilityManagement = 'healing',
    ProjectSecurityZones = 'network_locked',
    ProjectComponentsLibrary = 'shapes',
    ProjectAssetsAndItems = 'stack',
    ProjectItems = 'stack',
    ProjectUsers = 'group',
    AdminUsers = 'group',
    AdminStandards = 'library_books',
    AdminRequirements = 'library_books',
    AdminMappings = 'beenhere',
    AdminPSSProjectClassificationTemplates = 'book',
    ProjectTypeCustomer = 'handshake',
    ProjectTypeProductDevelopment = 'conveyor_belt',
    ProjectTypeStandardSolution = 'description',
    ProjectTypeService = 'center_focus_strong',
    ProjectTypeFactoryLifecycle = 'manufacturing',
    ProjectTypeDefault = 'square',
    FilterList = 'filter_list',
    Reorder = 'reorder',
    ExpandCircleDown = 'expand_circle_down',
    FilterListOff = 'filter_list_off',
    SortUp = 'arrow_upward',
    SortDown = 'arrow_downward',
    UnSorted = 'swap_vert',
    SendFeedback = 'mail',
    Cancel = 'cancel',
    Download = 'cloud_download',
    Upload = 'cloud_upload',
    MoreOptions = 'more_vert',
    Add = 'add',
    Forward = 'arrow_forward',
    Back = 'arrow_back',
    Edit = 'edit',
    Delete = 'delete',
    Save = 'save',
    Print = 'print',
    Share = 'share',
    Refresh = 'refresh',
    Search = 'search',
    Settings = 'settings',
    Help = 'help',
    Home = 'home',
    Favorite = 'favorite',
    Close = 'close',
    Menu = 'menu',
    Notification = 'notifications',
    Person = 'person',
    Lock = 'lock',
    Unlock = 'lock_open',
    Warning = 'warning',
    Error = 'error',
    Success = 'check_circle',
    Info = 'info',
    NorthEast = 'north_east',
    ChevronLeft = 'chevron_left',
    ChevronRight = 'chevron_right',
    ChevronUp = 'keyboard_arrow_up',
    ChevronDown = 'keyboard_arrow_down',
    ChevronStart = 'first_page',
    CompactView = 'list',
    RoomyView = 'lists',
    CopyToClipboard = 'content_copy',
    DeleteForever = 'delete_forever',
    Calendar = 'calendar_month',
    Summarize = 'summarize',
    Ballot = 'ballot',
    Comment = 'comment',
    VerifiedUser = 'verified_user',
    ThreatAndRiskAnalysis = 'health_and_safety',
    Draft = 'Draft',
    AttachFile = 'attach_file',
    Vulnerabilities = 'policy_alert',
}

// Global level icons
export const ComponentLibraryIcon = iconComponentGenerator(
    IconEntityMap.ComponentLibrary,
);
export const ProjectsIcon = iconComponentGenerator(IconEntityMap.Projects);
export const SecurityNotificationIcon = iconComponentGenerator(
    IconEntityMap.SecurityNotification,
);

// Project area icons
export const ProjectSecurityZonesIcon = iconComponentGenerator(
    IconEntityMap.ProjectSecurityZones,
);
export const ProjectAssetsAndItemsIcon = iconComponentGenerator(
    IconEntityMap.ProjectAssetsAndItems,
);
export const ProjectItemsIcon = iconComponentGenerator(
    IconEntityMap.ProjectItems,
);

// Admin area icons
export const AdminUsersIcons = iconComponentGenerator(IconEntityMap.AdminUsers);
export const AdminStandardsIcons = iconComponentGenerator(
    IconEntityMap.AdminStandards,
);
export const AdminRequirementsIcons = iconComponentGenerator(
    IconEntityMap.AdminRequirements,
);
export const AdminMappingsIcons = iconComponentGenerator(
    IconEntityMap.AdminMappings,
);
export const AdminPSSProjectClassificationTemplatesIcons =
    iconComponentGenerator(
        IconEntityMap.AdminPSSProjectClassificationTemplates,
    );

// Project Types
export const ProjectComponentsIcon = ComponentLibraryIcon;

// Grid icons
export const ForwardIcon = iconComponentGenerator(IconEntityMap.Forward);
export const ErrorIcon = iconComponentGenerator(IconEntityMap.Error);
export const InfoIcon = iconComponentGenerator(IconEntityMap.Info);
export const HelpIcon = iconComponentGenerator(IconEntityMap.Help);
export const NorthEastIcon = iconComponentGenerator(IconEntityMap.NorthEast);
export const CalendarIcon = iconComponentGenerator(IconEntityMap.Calendar);

// TabIcons
export const InfoTabIcon = InfoIcon;
export const SecurityNotificationTabIcon = SecurityNotificationIcon;
export const HelpTabIcon = HelpIcon;
export const SummarizeTabIcon = iconComponentGenerator(IconEntityMap.Summarize);
export const CommentTabIcon = iconComponentGenerator(IconEntityMap.Comment);
export const AffectedItemTabIcon = iconComponentGenerator(
    IconEntityMap.ProjectItems,
);
export const SecurityMeasureTabIcon = iconComponentGenerator(
    IconEntityMap.VerifiedUser,
);
export const MitigationTabIcon = iconComponentGenerator(
    IconEntityMap.ProjectTasks,
);
export const VulnerabilitiesTabIcon = iconComponentGenerator(
    IconEntityMap.Vulnerabilities,
);

export const AttachFileIcon = iconComponentGenerator(IconEntityMap.AttachFile);
